import { type UseQueryOptions, useQuery } from '@tanstack/vue-query'
import type { FetchCountriesSuccessResponse } from '../../types/api/response/country'
import { axiosInstance } from '@/modules/Core/plugins/axios'

export const QUERY_KEY = 'countries'
const ENDPOINT = '/Generic/Countries'

export function fetchCountries() {
  return axiosInstance
    .get<FetchCountriesSuccessResponse>(ENDPOINT)
    .then((response) => response.data)
}

export function useCountriesQuery(
  options?: UseQueryOptions<Awaited<ReturnType<typeof fetchCountries>>>
) {
  return useQuery({
    queryFn: () => fetchCountries(),
    queryKey: [QUERY_KEY],
    ...options,
  })
}
